export default [
  {
    type: "monthly",
    year: 2021,
    month: 1,
    btc: 0,
    source: ""
  },
  {
    type: "monthly",
    year: 2021,
    month: 2,
    btc: 0,
    source: ""
  },
  {
    type: "monthly",
    year: 2021,
    month: 3,
    btc: 0,
    source: ""
  },
  {
    type: "monthly",
    year: 2021,
    month: 4,
    btc: 0,
    source: ""
  },
  {
    type: "monthly",
    year: 2021,
    month: 5,
    btc: 0,
    source: ""
  },
  {
    type: "monthly",
    year: 2021,
    month: 6,
    btc: 0,
    source: ""
  },
  {
    type: "monthly",
    year: 2021,
    month: 7,
    btc: 0,
    source: ""
  },
  {
    type: "monthly",
    year: 2021,
    month: 8,
    btc: 0,
    source: ""
  },
  {
    type: "monthly",
    year: 2021,
    month: 9,
    btc: 0,
    source: ""
  },
  {
    type: "monthly",
    year: 2021,
    month: 10,
    btc: 0,
    source: ""
  },
  {
    type: "monthly",
    year: 2021,
    month: 11,
    btc: 0,
    source: ""
  },
  {
    type: "monthly",
    year: 2021,
    month: 12,
    btc: 0,
    source: ""
  },
  /* Quarterly */
  {
    type: "quarterly",
    year: 2020,
    quarter: 1,
    btc: 0,
    source: ""
  },
  {
    type: "quarterly",
    year: 2020,
    quarter: 2,
    btc: 0,
    source: ""
  },
  {
    type: "quarterly",
    year: 2020,
    quarter: 3,
    btc: 60,
    source: "https://bit-digital.com/press-releases/bit-digital-inc-announces-the-third-quarter-of-fiscal-year-2020-financial-results/"
  },
  {
    type: "quarterly",
    year: 2020,
    quarter: 4,
    btc: 262.62,
    source: "https://bit-digital.com/press-releases/bit-digital-inc-announces-2020-financial-highlights/"
  },
  {
    type: "quarterly",
    year: 2021,
    quarter: 1,
    btc: 581.23,
    source: "https://bit-digital.com/press-releases/bit-digital-inc-announces-first-quarter-of-fiscal-year-2021-financial-results/"
  },
  {
    type: "quarterly",
    year: 2021,
    quarter: 2,
    btc: 588.40,
    source: "https://bit-digital.com/press-releases/bit-digital-inc-announces-second-quarter-of-fiscal-year-2021-financial-results/"
  },
  {
    type: "quarterly",
    year: 2021,
    quarter: 3,
    btc: 0,
    source: ""
  },
  {
    type: "quarterly",
    year: 2021,
    quarter: 4,
    btc: 0,
    source: ""
  },
]
